import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25.05 50C11.23 50 0 38.7 0 25 0 11.23 11.23 0 25 0c15.447 0 25 13.008 25 25 .05 13.77-11.18 25-24.95 25zm0-46.443C13.213 3.557 3.558 13.16 3.558 25S13.16 46.443 25 46.443 46.443 36.84 46.443 25c.05-10.315-8.18-21.443-21.392-21.443z"
  })]
});